<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">CSV Skip Invoicing (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir" :disabled="!disabled">SEGUIR</b-button>
					<hr />
				</div>
			</div>
			<div class="row">
				<div class="col-10">
					<label class="control-label">A continuación: sube el archivo con la planilla completa</label>
					<upload-excel type="xls" :on-success="onSuccess" :before-upload="beforeUpload" />
				</div>
			</div>
			<p></p>
			<div v-if="error" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5>
						</div>
					</div>
				</div>
			</div>
			<div v-if="validacion" class="row">
				<div class="col-12">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-5">
							<b-input id="busquedas" size="sm" placeholder="Filtro..." v-model="filtro" />
						</div>
						<div v-if="filtro != ''" class="col-3 total-filtro">{{ totalFiltrados }} registros seleccionados</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-12" style="font-size: 14px">
							<b-table striped small :fields="campos" :items="getFacturas" :per-page="perPage" :current-page="currentPage" head-variant="light">
								<template #cell(fecha)="data">{{ formatDate(data.item["Sale date"]) }}</template>
								<template #cell(neto)="data">{{ Intl.NumberFormat("es-CL").format(data.value) }}</template>
							</b-table>
							<b-pagination v-model="currentPage" :total-rows="totalFiltrados" :per-page="perPage" size="sm" align="right"></b-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import UploadExcel from "./upload_excel.vue"


	export default 
	{
		name: "Paso5",
		components: { UploadExcel },
		props: {
			periodo: String, // Funcion callback para informar el periodo seleccionado
			confirmacion: false,
			onAvanzar: Function, // Funcion callback para la accion de avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				nombre: "skip", // Tipo de archivo a cargar
				formato: [ "sale_code", "sale_date", "issuer_name", "client_id", "client_name", "client_type", "region", "slug", "client_tax_code", "client_address", "client_city", "client_country", "client_post_code", "billing_period", "journey_id", "sale_description", "n_km", "sale_rectify_code", "sale_rectify_date", "sale_rectify_tax_region_state", "invoice_code", "invoice_date", "district", "price", "discount", "neto", "base_imponible", "iva.", "total" ],
				disabled: false, // Flag que controla el boton SEGUIR
				validacion: false,
				filtro: "",
				campos: [ 
					{ key: "fecha", label: "Date" }, 
					{ key: "Client id", label: "Client ID" }, 
					{ key: "Client name", label: "Client Name" }, 
					{ key: "Slug", label: "Slug" }, 
					{ key: "Client tax code", label: "Client Tax Code" }, 
					{ key: "Client country", label: "Client Country" }, 
					{ key: "Neto", label: "Neto" }, 
				],
				facturas: [],
				perPage: 5,
				currentPage: 1,
				error: false, // Flag que controla cuando mostrar el mensaje de error 
				mensaje: "",
			}
		},
		computed: {

			getFacturas() {

				return this.filtrar()
			},

			totalFiltrados() {

				return this.filtrar().length
			},
		},
		methods: {

			// Se ejecuta antes de comenzar a leer el archivo
			// Sirve para activar el icono de espera
			beforeUpload() {

				this.error = false

				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			// Se ejecuta una vez que se leyo todo el archivo
			// Desactiva el icono de espera y muestra los datos leidos en la tabla
			onSuccess(header, data, file) {

				// Ocultamos la imagen cargando
				window.event.$emit("mostrar-cargando", false)

				if (header.join() == this.formato.join()) {

					this.validacion = true
					this.facturas = data
					this.procesar()

					// Llamamos a la funcion callback para enviar la info del archivo cargado
					if (this.onArchivo)
						this.onArchivo({ archivo: this.nombre, nombre: file.name, tipo: file.type, tamanio: file.size, registros: data.length, avance: 0 })

				} else {

					this.mensaje = "El formato del archivo no corresponde"
					this.error = true
					this.validacion = false
				}
			},

			// Aplica el filtro ingresado al arreglo de facturas
			filtrar() {

				return this.facturas.filter((factura) => {

					return factura["Client id"].toString().toLowerCase().includes(this.filtro.toLowerCase()) 
				})
			},

			// Para convertir la fecha en formato Excel que viene en el archivo a DD/MM/YYYY (Validar si es necesario)
			formatDate(date) {

				var unix = (date - 25569) * 86400
				return moment.unix(unix).format("DD/MM/YYYY")
			},

			// Procesamos la data y avanzamos al Paso 6
			procesar() {

				// Recorremos el arreglo de facturas para crear el arreglo con la data que enviaremos al servidor
				var data = []
				for (var registro of this.facturas)
				{
					var tmp = {
						sale_date: registro["Sale date"],
						client_id: registro["Client id"],
						client_name: registro["Client name"],
						slug: registro["Slug"],
						client_tax_code: registro["Client tax code"],
						client_country: registro["Client country"],
						neto: registro["Neto"]
					}

					data.push(tmp)
				}

				// Estructura con la info que se enviara al servidor
				var request = {
					"usuario": this.$usuario, 
					"destino": this.$env,
					"tx": "F0",
					"proceso": "upDataFac",
					"archivo": this.nombre,
					"periodo": this.periodo,
					"data": data
				}	

				// Llamada a la API
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" }, }).then(response => {

					if (response.data.estatus == "OK")
						this.disabled = true // Activamos el boton SEGUIR
					else {

						this.mensaje = response.data.estatus
						this.error = true
					}

				}).catch(ex => {

					// Si hubo un error, pasamos por aca y lo registramos
					console.log(ex.message)
				})
			},

			seguir() {

				// Llamamos a la funcion callback
				if (this.onAvanzar)
					this.onAvanzar()
			}
		}
	}

</script>
<style scoped>

	.total-filtro {
		padding-top: 3px;
		font-size: 14px;
	}

</style>
